import { LayoutType } from "@components/shared/layouts"
import React from "react"
import { TitleParagraph, Title1ContainerDiv } from "../quote-screen/quote-screen.styles"

export const Screen1Title = React.forwardRef(
	(
		{
			z,
			title,
			size,
		}: {
			z: number
			title: string
			size: keyof typeof LayoutType
		},
		ref: React.ForwardedRef<HTMLDivElement>
	) => {
		return (
			<Title1ContainerDiv z={z} ref={ref}>
				<TitleParagraph size={size}>{title}</TitleParagraph>
			</Title1ContainerDiv>
		)
	}
)
